var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTeamSolid = function SvgTeamSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 19.5h18",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.333A2.667 2.667 0 1 0 12 6a2.667 2.667 0 0 0 0 5.333Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 19.333v-2.666A2.667 2.667 0 0 1 10.667 14h2.666A2.667 2.667 0 0 1 16 16.667v2.666",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 19.333v-2.666A2.667 2.667 0 0 1 10.667 14h2.666A2.667 2.667 0 0 1 16 16.667v2.666",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 11.333A2.667 2.667 0 1 0 17 6c.167.278 1 1.2 1 2.667 0 1.466-.833 2.389-1 2.666ZM20.22 14.781c-.501-.5-1.18-.781-1.886-.781.222.278.666 1.2.666 2.667v2.666h2v-2.666c0-.708-.28-1.386-.78-1.886ZM7 11.333A2.667 2.667 0 1 1 7 6c-.167.278-1 1.2-1 2.667 0 1.466.833 2.389 1 2.666ZM3.78 14.781c.501-.5 1.18-.781 1.887-.781-.223.278-.667 1.2-.667 2.667v2.666H3v-2.666c0-.708.28-1.386.78-1.886Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgTeamSolid;